import { gql } from '@apollo/client';

export const GET_ACTION_CARD_ITEMS = gql(/* GraphQL */ `
    query GetActionCardItems($responsibleUserIds: [String!]!) {
        getActionCardItems(responsibleUserIds: $responsibleUserIds) {
            id
            action
            completed
            dueBy
            priceChangeRequestId
            proposedPrice
            productSku
            productDescription
            productCategoryName
            storeName
            storeNo
            responsibleUserFirstName
            responsibleUserLastName
            isFromPriceSurvey
            priceSurveyType
            priceSurveyLabel
            advertisingZoneName
            priceChangeScope
        }
    }
`);

export const GET_ACTIONS_FOR_REQUEST = gql(/* GraphQL */ `
    query GetActionsForRequest($requestId: String!) {
        getPriceChangeRequestActionsByPriceChangeRequestId(
            priceChangeRequestId: $requestId
        ) {
            id
            action
            completed
            dueBy
            possibleOutcomes
            responsibleUser {
                id
                firstName
                lastName
            }
            priceChangeRequestStatus {
                id
                createdAt
                status
                note
            }
        }
    }
`);
